module.exports = __webpack_public_path__ + "static/img/Logo-eDoatap_Color.788a50f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo-eDoatap_Color.png
// module id = 0BuK
// module chunks = 1